import React, { useEffect, useState } from "react";
import CreditCardIcon from "../../../../../assets/disabilityIcons/creditCard.svg";
import BUDGET_API from "../../../../../apis/budget.api";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import "./styles/budget.css";
import formatAmount from "../../../../../helpers/formatAmount";

const SliderComponent = ({
  icon,
  description,
  min = 0,
  max = 10000,
  step = 1,
  amount = 0,
  loading,
  setFormData,
  item,
}) => {
  const [value, setValue] = useState(item.disabilityBudget ? item.disabilityBudget : item.amount || min);

  const handleChange = (e) => {
    e.persist();
    const newValue = Number(e.target.value);
    setValue(newValue);

    setFormData((prev = []) => {
      const updatedFormData =
        prev !== null &&
        prev.map((entry) =>
          entry.categoryId === item.categoryId ? { ...entry, disabilityBudget: newValue } : entry
        );

      return prev.some((entry) => entry.categoryId === item.categoryId)
        ? updatedFormData
        : [...prev, { categoryId: item.categoryId, id: item.id, disabilityBudget: newValue }];
    });
  };
  console.log("itemee", item);
  return (
    <div className="slider-component">
      <div className="left-container">
        <div className="icon-container">{icon && <img src={icon} alt="icon" />}</div>
        <div className="icon-description-container">
          <h4 className="icon-description">{item.budgetCategory.categoryName}</h4>
        </div>
      </div>

      <div className="mid-container">
        <div className="min-max-container">
          <div className="amount-container">
            <p className="amount-title">${formatAmount(value)}</p>
          </div>
          <div className="max-amount-container">
            <p className="amount-title">${max}</p>
          </div>
        </div>

        <div className="slider-input-container">
          <input
            type="range"
            name={item.budgetCategory.categoryName}
            className="slider-input"
            min={min}
            max={max}
            step={step}
            defaultValue={item.disabilityBudget ? item.disabilityBudget : item.amount}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="right-container">
        <div className="amount-input-container">
          <input
            type="text"
            className="amount-input"
            onChange={handleChange}
            value={`$${formatAmount(value)}`}
          />
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};

const SlidersContainer = ({ setFormData }) => {
  const [budgetData, setBudgetData] = useState(null);
  console.log("budgetData", budgetData);
  const [loading, setLoading] = useState(false);

  const getAllBudget = async () => {
    setLoading(true);
    const date = moment();
    const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
    const endDate = date.endOf("month").format("YYYY-MM-DD");
    let data = await BUDGET_API.fetchAllBudget(startDate, endDate, "all");
    console.log("dataaaaaaaaa", data);
    setBudgetData(data.categorized);
    setLoading(false);
  };
  useEffect(() => {
    getAllBudget();
  }, []);
  return (
    <div className="sliders-container">
      {budgetData &&
        budgetData.map((item, index) => (
          <SliderComponent
            key={index}
            icon={CreditCardIcon}
            // description={item.budgetCategory.categoryName}
            // amount={item.amount}
            item={item}
            min={0}
            max={3 * item.amount}
            step={1}
            loading={loading}
            setFormData={setFormData}
          />
        ))}
      <NewLoader isLoading={loading} />
    </div>
  );
};

export default SlidersContainer;
